import React from 'react';
import styles from '../styles/closeButton.module.scss';

export default function CloseButton(props: { close: () => void }) {
  return <div className={styles.closeButton} onClick={props.close} />;
}
